// ----------------------------------------------------------------------------
// Snippet: Gift Card Recipient's Form
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_gift-card-recipient-form.scss';

if (!customElements.get('recipient-form')) {
    customElements.define('recipient-form', class RecipientForm extends HTMLElement {
        constructor() {
            super();
            this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
            this.checkboxInput.disabled = false;
            this.recipientFields = this.querySelector(`#Recipient-fields-${this.dataset.sectionId}`);
            this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
            this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
            this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
            this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);

            this.addEventListener('change', this.onChange.bind(this));
            this.onChange();
        }
        
        onChange() {
            if (this.checkboxInput.checked) {
                this.checkboxInput.setAttribute('aria-expanded', true);
                this.recipientFields.hidden = false;
                this.enableInputFields();
            } else {
                this.checkboxInput.setAttribute('aria-expanded', false);
                this.recipientFields.hidden = true;
                this.disableInputFields();
            }
        }
        
        inputFields() {
            return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
        }
        
        enableInputFields() {
            this.inputFields().forEach((field) => (field.disabled = false));
        }

        disableInputFields() {
            this.inputFields().forEach((field) => (field.disabled = true));
        }
    });
}

